import {authHeader, ApiConfigs} from "../_helpers";
import { authService } from "./auth.service";

export const currencyService = {
    getAll,
    create,
    delete: _delete,
    update,
    getList,
    getAllWithoutPagination
};

function getAll(page : number , perPage : any) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.currency.getAll}?page=${page}&per_page=${perPage}`, requestOptions)
        .then(
            handleResponse
        );
}

function getAllWithoutPagination() {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.currency.getAll}?pagination=off`, requestOptions)
        .then(
            handleResponse
        );
}








function create(payload:object ){
    const requestOptions = {
        method: "POST",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.currency.add}`, requestOptions)
        .then(
            handleResponse
        );
}




function _delete(id: string){
    const requestOptions={
        method:"DELETE",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },

    }

    return fetch(`${ApiConfigs.base_url+ApiConfigs.currency.delete.replace(':id', id)}`, requestOptions)
        .then(handleResponse);
}


function update(id: string, payload: object){
    console.log('ertert', id)
    const requestOptions={
        method:"PUT",
        credentials : 'include' as RequestCredentials,
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    }

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.currency.update.replace(':id', id)}`, requestOptions)
    .then(handleResponse);
}

function getList() {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.currency.getList}`, requestOptions)
        .then(
            handleResponse
        );
}



function handleResponse(response: any) {
    return response.text().then((text: string) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('user');
                localStorage.removeItem("store");

                location.reload();
                authService.logout();
            }
            const error = (data && data.message) || response.status || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}